import { useState } from 'react'
import { useRouter } from "next/router";
import { RadioGroup } from '@headlessui/react'
import Carousel from 'nuka-carousel'
import Link from 'next/link';
import ReactMarkdown from 'react-markdown'
import Head from 'next/head';

export default function ShowcaseLayout({ children, ...frontMatter }) {
  const share = useRouter()
  const base = "https://www.datopian.com"
  const links = base + share.asPath
  const { title, subtitle, image, images, description, features, services, impact, link, seotitle, casestudy, website } = frontMatter;
  return (
    <div className="bg-white">
      <Head><title>{seotitle ? seotitle : title}</title> </Head>
      <div className="pt-24 md:pt-16">
        <div className='flex flex-col items-center text-center w-full'>
          <h1 className="text-center main-top-title w-full">{title}</h1>
          <h2 className="text-center main-title w-full py-6">{subtitle}</h2>
          <Carousel
            scrollMode="page" cellAlign="center" className="max-w-7xl">
            {images.map((image) => (
              <div className="flex justify-center px-8" key={image}>
                <div className="max-w-7xl">
                  <img className="object-contain" src={image} alt="Portal Capture Image" />
                </div>
              </div>
            ))}
          </Carousel>
        </div>

        <div className="mx-auto max-w-2xl px-4 pb-16 pt-10 sm:px-6 grid lg:max-w-7xl lg:grid-cols-3 lg:grid-rows-[auto,auto,1fr] lg:gap-x-8 lg:px-8 lg:pb-24 lg:pt-16">
          <div className="lg:col-span-2 lg:border-r lg:border-gray-200 lg:pr-8">
            <h3 className="medium-title">Project Overview</h3>
          </div>
          <div className="mt-4 lg:row-span-3 lg:mt-0">
            <h2 className="sr-only">Portal information</h2>
            <h3 className="font-bold font-['Inter'] text-maingray text-xl">Impact</h3>

            <div className="mt-6">
              {/* Right Panel */}
              <div className="main-text !font-normal">
                <div className="pb-8 showcase-style">
                  <ReactMarkdown>{impact}</ReactMarkdown>
                </div>
              </div>
              <div className="flex flex-col gap-5">
                <Link href={link} target='_blank'>
                  <button
                    className="btn-primary"
                  >
                    {website? "See client website"  : "See the portal"}
                  </button>
                </Link>
                {casestudy &&
                  <Link href={`/showcase/case-studies/${casestudy}`}>
                    <button
                      className="btn-primary"
                    >
                      Read the Case Study
                    </button>
                  </Link>
                }
              </div>
              <div className="flex gap-2 mt-8">
                <a href={`https://www.twitter.com/intent/tweet?text=${links}`} target="_blank">
                  <div className="hover:bg-orange-400 hover:cursor-pointer w-8 h-8 border border-1 rounded-lg flex items-center justify-center">
                    <img className="fill" src="/assets/images/logos/social-logo-twt.svg" alt="Twitter logo" />
                  </div>
                </a>
                <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${links}`} target="_blank">
                  <div className="hover:bg-orange-400 hover:cursor-pointer w-8 h-8 border border-1 rounded-lg flex items-center justify-center">
                    <img className="" alt="Linkedin logo" src="/assets/images/logos/social-logo-lin.svg" />
                  </div>
                </a>
                <a href={`https://www.facebook.com/dialog/share?app_id=145634995501895&display=popup&href=${links}`} target="_blank">
                  <div className="hover:bg-orange-400 hover:cursor-pointer w-8 h-8 border border-1 rounded-lg flex items-center justify-center">
                    <img className="" alt="Facebook Logo" src="/assets/images/logos/social-logo-fb.svg" />
                  </div>
                </a>
                <a href={`https://www.mastodon.social/share?text=${links}`} target="_blank">
                  <div className="hover:bg-orange-400 hover:cursor-pointer w-8 h-8 border border-1 rounded-lg flex items-center justify-center">
                    <img className="" alt="Mastodon Logo" src="/assets/images/logos/social-logo-md.svg" />
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div className="row-start-2 lg:row-start-auto py-10 lg:col-span-2 lg:col-start-1 lg:border-r lg:border-gray-200 lg:pb-16 lg:pr-8 lg:pt-6">
            {/* Description and details */}
            <div className="main-text !font-normal showcase-style">
              <ReactMarkdown>{description}</ReactMarkdown>
            </div>
            <h3 className="font-bold font-['Inter'] text-maingray text-xl py-4">Key Features & Functionality</h3>
            <div className="main-text !font-normal">
              <ul className="list-disc list-inside showcase-style">
                {features.map((feature) => (
                  <li key={feature} className='flex gap-4 py-1.5'>•<ReactMarkdown>{feature}</ReactMarkdown></li>
                ))}
              </ul>
            </div>
            <h3 className="font-bold font-['Inter'] text-maingray text-xl py-4">Services Provided</h3>
            <div className="main-text !font-normal">
              <ul className="list-inside showcase-style">
                {services.map((service) => (
                  <li key={service} className='flex gap-4 py-1.5'>•<ReactMarkdown>{service}</ReactMarkdown></li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}  